<template>
	<div class="clearfix py-2 d-flex align-items-center" @click="showComplete()">
		<div class="flex-grow-1">{{location.title.trunc(20)}}</div>
		<div class="" v-if="weather.forecast">
			<small class="text-muted">Today's Forecast</small>
			<img :src="'https://cdn.aerisapi.com/wxicons/v2/'+weather.forecast[0].icon" style="width: 30px" />
			{{weather.forecast[0].avgTempF}}&deg; F
			<img src="~assets/img/icons/humidity.png" style="width: 30px" />
			{{weather.forecast[0].humidity}}%
		</div>
	</div>
</template>

<script>

	import {mapState} from 'vuex'


	export default {
		name: 'ForecastLine',
		data() {
			return {

			}
		},
		watch: {

		},
		computed: {
			...mapState([
				'weather',
				'location'
			])
		},
		mounted() {

		},
		methods: {
			showComplete() {

			}
		},
	}
</script>

